var OrgTypes = require("lib/academic/OrgTypes");

var moment = require("moment");

export function getPath(state) {
	var fullPath = "/orgs";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
		if (state.orgIdentifier)  {
			fullPath += "/" + state.orgIdentifier;
		}
	}

	var queryParts = [];


	if (state.startDate) {
		queryParts.push("start_date=" + state.startDate);
	} else {
		queryParts.push("start_date=" + moment().subtract(30, "days").format("YYYY-MM-DD"));
	}
	if (state.endDate) {
		queryParts.push("end_date=" + state.endDate);
	} else {
		queryParts.push("end_date=" + moment().format("YYYY-MM-DD"));
	}

	if (queryParts.length) {
		fullPath += "?" + queryParts.join("&");
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	if (params.active_view) {
		state.activeView = params.active_view;

		if (params.org_identifier)  {
			state.orgIdentifier = params.org_identifier;
		}
	} else {
		state.activeView = VIEWS.TABLE;
	}

	if (params.start_date) {
		state.startDate = params.start_date;
	} else {
		state.startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
	}
	if (params.end_date) {
		state.endDate = params.end_date;
	} else {
		state.endDate = moment().format("YYYY-MM-DD");
	}


	return state;
}

export var PATH = "/orgs/:active_view?/:org_identifier?";

export var VIEWS = {
	TABLE: "table"
}


// WEBPACK FOOTER //
// ./modules/lib/routing/OrgActivityRouting.js